/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ch_1_TInputs */

const en_cp_ch_1_t = /** @type {(inputs: Cp_Ch_1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Process`)
};

const id_cp_ch_1_t = /** @type {(inputs: Cp_Ch_1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proses`)
};

/**
* | output |
* | --- |
* | "Process" |
*
* @param {Cp_Ch_1_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ch_1_t = /** @type {((inputs?: Cp_Ch_1_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ch_1_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ch_1_t(inputs)
	return en_cp_ch_1_t(inputs)
});